module.exports = __webpack_public_path__ + "img/reset.8f017fd3.png";